import { render, staticRenderFns } from "./FormFieldsV3.vue?vue&type=template&id=81ba0926"
import script from "./FormFieldsV3.vue?vue&type=script&lang=js"
export * from "./FormFieldsV3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports